<template>
    <div class="custom-container">
        <el-tabs v-model="activeName">
            <el-tab-pane label="岗位实习现场指导记录表" name="first">
                <div v-if="type === 'mobile'">
                    <el-form label-width="100px" label-position="left" width="100%">
                        <el-form-item label="指导教师">
                            <span>{{ form.teaName }}</span>
                        </el-form-item>
                        <el-form-item label="实习学生">
                            <el-select v-if="userType !== 'stu'" v-model="form.stuCode" :placeholder="stuText"
                                       multiple clearable :disabled="stuFlag" @change="changeStu">
                                <el-option v-for="(item, index) in stuOption" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                            <span>{{ form.stuName }}</span>
                        </el-form-item>
                        <el-form-item label="班级">
                            <span>{{ form.className }}</span>
                        </el-form-item>
                        <el-form-item label="单位名称">
                            <el-select v-if="userType !== 'stu'" v-model="form.unitName" style="width: 100%"
                                       placeholder="请选择实习单位" @change="changeUnit">
                                <el-option v-for="(item, index) in comboOption.unit" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                            <span v-if="userType === 'stu'">{{ form.unitName }}</span>
                        </el-form-item>
                        <el-form-item label="实习岗位">
                            <el-select v-if="userType !== 'stu'" v-model="form.postName" multiple
                                       style="width: 100%" placeholder="请选择实习岗位">
                                <el-option v-for="(item, index) in tempPost" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                            <span v-if="userType === 'stu'">{{ form.postName.join() }}</span>
                        </el-form-item>
                        <el-form-item label="指导时间">
                            <el-date-picker v-if="userType !== 'stu'" placeholder="请选择指导时间"
                                            v-model="form.recordDate" type="date" value-format="yyyy-MM-dd"
                                            style="width: 100%"/>
                            <span v-if="userType === 'stu'">{{ form.recordDate }}</span>
                        </el-form-item>
                        <el-form-item label="企业带教教师">
                        </el-form-item>
                        <el-form-item label="联系电话">
                        </el-form-item>
                        <el-form label-position="top" width="100%">
                            <el-form-item label="指导内容">
                                <el-input v-if="userType !== 'stu'" type="textarea" :rows="5" maxlength="500"
                                          show-word-limit v-model="form.content1"/>
                                <span v-if="userType === 'stu'">{{ form.content1 }}</span>
                            </el-form-item>
                            <el-form-item label="企业带教教师交流记录">
                                <el-input v-if="userType !== 'stu'" type="textarea" :rows="5" maxlength="500"
                                          show-word-limit v-model="form.content2"/>
                                <span v-if="userType === 'stu'">{{ form.content2 }}</span>
                            </el-form-item>
                            <el-form-item label="现场指导情况总结">
                                <el-input v-if="userType !== 'stu'" type="textarea" :rows="5" maxlength="500"
                                          show-word-limit v-model="form.content3"/>
                                <span v-if="userType === 'stu'">{{ form.content3 }}</span>
                            </el-form-item>
                        </el-form>
                    </el-form>
                </div>

                <div v-else style="height: 600px; overflow: auto; margin-left:20px;">
                    <el-form ref="form" :model="form" width="100%">
                        <table border="1" cellpadding="0" cellspacing="0" class="tableStyle">
                            <col width="81.13"/>
                            <col width="80"/>
                            <col width="60"/>
                            <col width="82.47"/>
                            <col width="80"/>
                            <col width="121.53"/>
                            <col width="60"/>
                            <col width="160"/>
                            <tr>
                                <td style="line-height: 45px;">
                                    <span class="font">
                                        指导教师
                                    </span>
                                </td>
                                <td colspan="2">
                                    <span class="font">
                                        {{ form.teaName }}
                                    </span>

                                </td>
                                <td>
                                    <span class="font">
                                        实习学生
                                    </span>
                                <td colspan="2">
                                    <el-select v-if="userType !== 'stu'" v-model="form.stuCode" :placeholder="stuText"
                                               multiple clearable :disabled="stuFlag" @change="changeStu">
                                        <el-option v-for="(item, index) in stuOption" :key="item.comboValue"
                                                   :value="item.comboValue" :label="item.comboName">
                                        </el-option>
                                    </el-select>
                                    <span v-if="userType === 'stu'" class="font">
                                        {{ form.stuName }}
                                    </span>
                                </td>
                                <td>
                                    <span class="font">
                                        班级
                                    </span>
                                </td>
                                <td>
                                    <span class="font">
                                        {{ form.className }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" style="line-height: 45px;">
                                    <span class="font">
                                        单位名称
                                    </span>
                                </td>
                                <td colspan="6">
                                    <el-select v-if="userType !== 'stu'" v-model="form.unitName" style="width: 100%"
                                               placeholder="请选择实习单位" @change="changeUnit">
                                        <el-option v-for="(item, index) in comboOption.unit" :key="item.comboValue"
                                                   :value="item.comboValue" :label="item.comboName">
                                        </el-option>
                                    </el-select>
                                    <span v-if="userType === 'stu'" class="font">
                                        {{ form.unitName }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" style="line-height: 45px;">
                                    <span class="font">
                                        实习岗位
                                    </span>
                                </td>
                                <td colspan="3">
                                    <el-select v-if="userType !== 'stu'" v-model="form.postName" multiple
                                               style="width: 100%" placeholder="请选择实习岗位">
                                        <el-option v-for="(item, index) in tempPost" :key="item.comboValue"
                                                   :value="item.comboValue" :label="item.comboName">
                                        </el-option>
                                    </el-select>
                                    <span v-if="userType === 'stu'" class="font">
                                        {{ form.postName.join() }}
                                    </span>
                                </td>
                                <td>
                                    <span class="font">
                                        指导时间
                                    </span>
                                </td>
                                <td colspan="2">
                                    <el-date-picker v-if="userType !== 'stu'" placeholder="请选择指导时间"
                                                    v-model="form.recordDate" type="date" value-format="yyyy-MM-dd"
                                                    style="width: 100%"/>
                                    <span v-if="userType === 'stu'" class="font">
                                        {{ form.recordDate }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" style="line-height: 45px;">
                                    <span class="font">
                                        企业带教教师
                                    </span>
                                </td>
                                <td colspan="3">

                                </td>
                                <td>
                                    <span class="font">
                                        联系电话
                                    </span>
                                </td>
                                <td colspan="2">

                                </td>
                            </tr>
                            <tr>
                                <td colspan="8" style="text-align: left;">
                                    <span class="font">
                                        指导内容：
                                        <br>
                                        <el-input v-if="userType !== 'stu'" type="textarea" :rows="5" maxlength="500"
                                                  show-word-limit v-model="form.content1"/>
                                        <div v-if="userType === 'stu'" style="height:115px; overflow:auto;">
                                            {{ form.content1 }}
                                        </div>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="8" style="text-align: left;">
                                    <span class="font">
                                        企业带教教师交流记录：
                                        <br>
                                        <el-input v-if="userType !== 'stu'" type="textarea" :rows="5" maxlength="500"
                                                  show-word-limit v-model="form.content2"/>
                                        <div v-if="userType === 'stu'" style="height:115px; overflow:auto;">
                                            {{ form.content2 }}
                                        </div>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="8" style="text-align: left;">
                                    <span class="font">
                                        现场指导情况总结：
                                        <br>
                                        <el-input v-if="userType !== 'stu'" type="textarea" :rows="5" maxlength="500"
                                                  show-word-limit v-model="form.content3"/>
                                        <div v-if="userType === 'stu'" style="height:115px; overflow:auto;">
                                            {{ form.content3 }}
                                        </div>
                                        <!--                                        <div style="float: right;margin-right: 50px">-->
                                        <!--                                            教师签名：-->
                                        <!--                                            <br/>-->
                                        <!--                                            年&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;日-->
                                        <!--                                        </div>-->
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </el-form>
                </div>


                <div v-if="userType==='tea' && type !== 'mobile'"
                     style="width:100%; text-align:center; margin-bottom:20px;">
                    <el-button type="primary" @click="saveRec">保 存</el-button>
                    <el-button @click="callback">关 闭</el-button>
                </div>


            </el-tab-pane>
            <el-tab-pane label="现场指导照片" name="second">
                <div style="height: 600px;overflow: auto">
                    <div v-if="imageFlag">
                        <el-upload v-if="userType==='stu'" accept=".png,.jpeg,.jpg" action :http-request="uploadPhoto"
                                   :file-list="fileImgList" list-type="picture-card" :class="'hidden-Btn'"
                                   :disabled="true"
                                   :on-preview="handlePictureCardPreview"><i class="el-icon-plus"></i>
                            <template slot="file" slot-scope="{ file }">
                                <div class="el-upload-list__item-thumbnail">
                                    <img width="146px" height="146px" :src="file.url" alt=""/>
                                </div>
                                <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>
                                    <span v-if="userType!=='stu'" class="el-upload-list__item-delete"
                                          @click="handleRemove(file)">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </template>
                        </el-upload>

                        <el-upload v-else-if="userType!=='stu' && type !== 'mobile'" accept=".png,.jpeg,.jpg" action
                                   :http-request="uploadPhoto"
                                   :file-list="fileImgList" list-type="picture-card"
                                   :on-preview="handlePictureCardPreview"
                                   :on-remove="handleRemove">
                            <i class="el-icon-plus"></i>
                        </el-upload>


                        <el-upload v-else accept="image/*" action :http-request="uploadPhoto"
                                   :before-upload="beforeUpload"
                                   :file-list="fileImgList" list-type="picture-card"
                                   :on-preview="handlePictureCardPreview"
                                   :on-remove="handleRemove">
                            <i class="el-icon-plus"></i>
                        </el-upload>

                        <previewer v-if="previewerVisible" ref="previewer" :fileInfo="fileInfo"
                                   :widthPercent="60" :heightNum="650" :topNum="60"
                                   @closePreviewer="previewerVisible = false;">
                        </previewer>
                    </div>
                    <div v-else
                         style="width:100%; text-align:center; font-size:18px; font-weight:bold; color:#a7a8ac; margin-top:50px;">
                        首次保存现场指导记录后可上传照片
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import {showNotify} from "../../utils/message";
import {globalConfig} from "../../../static/config";
import previewer from 'views/file/previewer.vue';

export default {
    components: {
        previewer,
    },
    props: ['userName', 'userCode', 'userType', 'id', 'recType', 'dialogWidth', 'type'],
    showUploadBtn: {
        type: Boolean,
        default: true,
    },
    data() {
        return {
            previewerVisible:false,
            fileInfo: {
                name: null,
                type: null,
                url: null,
            },
            form: {
                id: '',
                teaName: '',
                teaCode: '',
                stuName: '',
                stuCode: '',
                className: '',
                unitName: [],
                postName: [],
                recordDate: '',
                content1: '',
                content2: '',
                content3: '',
                date: ''
            },
            fileImgList: [],
            photoDialogVisible: false,
            dialogImageUrl: '',
            activeName: 'first',
            stuOption: [],
            imageFlag: true,
            photoTitle: '',
            tempPost: [],
            newFlag: false,
            comboOption: {
                unit: []
            },
            stuFlag: true,
            stuText: '请先选择实习单位'
        }
    },
    mounted() {
        if (this.type === 'mobile') {
            this.dialogWidth = '90%'
        } else {
            this.dialogWidth = '60%'
        }

        if (this.recType !== 'add') {
            this.loadPhoto()
            this.loadRecordTable()
            this.newFlag = false
            this.stuFlag = false
        } else {
            this.form.teaName = this.userName
            this.form.teaCode = this.userCode
            this.loadStuCombo('add')
            this.loadUnitCombo('add')
            this.newFlag = true
            this.imageFlag = false
        }
    },
    methods: {
        beforeUpload(file) {
            var testmsg = (file.name.substring(file.name.lastIndexOf(".") + 1)).toLocaleLowerCase();
            const extension1 = testmsg === "jpg";
            const extension2 = testmsg === "jpeg";
            const extension3 = testmsg === "bmp";
            const extension4 = testmsg === "png";
            if (!extension1 && !extension2 && !extension3 && !extension4) {
                this.$message({
                    message: "仅允许上传 jpg、jpeg、bmp、png 图片文件！当前文件格式为：" + testmsg,
                    type: "info",
                    offset: 80,
                });

                return false;
            } else {
                return true;
            }
        },
        changeUnit() {
            this.form.stuCode = []
            this.form.postName = []
            this.form.className = ''
            this.loadStuCombo()

            if (this.form.unitName !== '') {
                this.stuFlag = false
                this.stuText = '请选择实习生'
            }

        },
        loadUnitCombo(type) {
            let code = '';
            if (type === 'add') {
                code = this.userCode
            } else {
                code = this.form.teaCode
            }
            this.$api.postPracticeManage.recordTable.loadUnitCombo({
                data: code
            })
                .then((res) => {
                    this.comboOption.unit = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadStuCombo(type) {
            let form = {}
            if (type === 'add') {
                form = {
                    'userCode': this.form.teaCode,
                    'unitName': this.form.unitName
                }
            } else {
                form = {
                    'userCode': this.userCode,
                    'unitName': this.form.unitName,
                    'id': this.id
                }
            }

            this.$api.postPracticeManage.recordTable.loadStuCombo({
                data: form,
            })
                .then((res) => {
                    this.stuOption = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadRecordTable() {
            this.$api.postPracticeManage.recordTable.loadRecordTable({
                data: this.id
            })
                .then((res) => {
                    this.form = res.data.data.recordTable
                    this.form.stuCode = this.form.stuCode.split(',')
                    this.form.postName = this.form.postName.split(',')
                    this.loadStuClass()
                    this.loadStuCombo()
                    this.loadUnitCombo()
                    this.tempPost = res.data.data.option.postOption
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadPhoto() {
            this.$api.postPracticeManage.recordTable.loadPhoto({
                data: this.id
            }).then((res) => {
                this.fileImgList = res.data.data
                this.fileImgList.forEach(item => {
                    item.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + item.url
                })
            }).catch((err) => {
                console.log(err);
            });
        },
        handlePictureCardPreview(file) {
            this.fileInfo.name = file.name;
            this.fileInfo.url = file.url;
            this.fileInfo.type = file.type;
            this.previewerVisible = true;
        },
        handleRemove(file, fileList) {
            this.$api.postPracticeManage.recordTable.removePhoto({
                data: file.id,
            }).then((res) => {
                if (res.data.data == 'success') {
                    showNotify('成功', '删除成功', 'success', 1500);

                    for (let i = 0; i < this.fileImgList.length; i++) {
                        if (this.fileImgList[i].id === file.id) {
                            this.fileImgList.splice(i, 1);
                            break;
                        }
                    }

                } else {
                    showNotify('失败', '删除失败', 'error', 3000);
                    this.loadPhoto()
                }
            }).catch((err) => {
                showNotify('错误', err, 'error', 3000);
            });
        },
        //上传照片
        uploadPhoto(param) {
            let formData = new FormData();
            formData.append('file', param.file);
            formData.append('id', this.form.id)
            formData.append('userCode', this.userCode);
            this.$api.postPracticeManage.recordTable.uploadPhoto({
                data: formData
            })
                .then((res) => {
                    if (res.data.data.state == 'success') {
                        showNotify('成功', '上传成功', 'success', 1500);
                        res.data.data.photo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + res
                            .data.data.photo.url
                        this.fileImgList.push(res.data.data.photo)
                    } else {
                        showNotify('失败', '上传失败', 'error', 3000);
                        this.loadPhoto()
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        saveRec() {
            if (this.form.stuCode.length === 0) {
                this.$alert('请选择实习学生', '提示', {
                    confirmButtonText: '确定'
                });
                return;
            }
            if (this.form.unitName == null || this.form.unitName == '') {
                this.$alert('请选择单位名称', '提示', {
                    confirmButtonText: '确定'
                });
                return;
            }
            if (this.form.postName == null || this.form.postName == '') {
                this.$alert('请选择实习岗位', '提示', {
                    confirmButtonText: '确定'
                });
                return;
            }
            if (this.form.recordDate == null || this.form.recordDate == '') {
                this.$alert('请选择指导时间', '提示', {
                    confirmButtonText: '确定'
                });
                return;
            }
            if (this.form.content1 == null || this.form.content1 == '') {
                this.$alert('请填写指导内容', '提示', {
                    confirmButtonText: '确定'
                });
                return;
            }
            if (this.form.content2 == null || this.form.content2 == '') {
                this.$alert('请填写企业带教教师交流记录', '提示', {
                    confirmButtonText: '确定'
                });
                return;
            }
            if (this.form.content3 == null || this.form.content3 == '') {
                this.$alert('请填写现场指导情况总结', '提示', {
                    confirmButtonText: '确定'
                });
                return;
            }

            let stuCode = this.form.stuCode.join();
            let stuName = "";
            this.stuOption.forEach(i => {
                this.form.stuCode.forEach(j => {
                    if (i.comboValue === j) {
                        stuName += i.comboName + ","
                    }
                })
            })
            stuName = stuName.substring(0, stuName.length - 1)

            let form = {
                id: this.form.id,
                teaCode: this.userCode,
                stuName: stuName,
                stuCode: stuCode,
                unitName: this.form.unitName,
                postName: this.form.postName.join(),
                recordDate: this.form.recordDate,
                content1: this.form.content1,
                content2: this.form.content2,
                content3: this.form.content3
            }
            this.$api.postPracticeManage.recordTable.save({
                data: form,
            }).then((res) => {
                if (res.data.data == 'success') {
                    showNotify('成功', '保存成功', 'success', 1500);
                    this.callback()
                    this.imageFlag = true;
                } else {
                    showNotify('失败', '保存失败', 'error', 3000);
                }
            }).catch((err) => {
                showNotify('错误', err, 'error', 3000);
            });
        },
        changeStu() {
            this.loadStuClass()
            this.loadStuPost()
        },
        loadStuPost() {
            this.form.postName = []
            if (this.form.stuCode.length === 0) {
                this.form.postName = '';
                return;
            }

            this.$api.postPracticeManage.recordTable.loadStuPost({
                data: this.form.stuCode,
            })
                .then((res) => {
                    this.tempPost = res.data.data.postOption
                    this.form.postName = res.data.data.post
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadStuClass() {
            if (this.form.stuCode.length === 0) {
                this.form.className = '';
                return;
            }
            this.$api.postPracticeManage.recordTable.loadStuClass({
                data: this.form.stuCode,
            })
                .then((res) => {
                    this.form.className = res.data.data

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        callback() {
            this.$emit("callback");
        },
    }
}
</script>

<style lang="scss">
.custom-container .el-tabs__item {
    height: 60px;
    line-height: 60px;
    width: 60% !important;
    text-align: center;
    padding: 0;
}

.custom-container .el-tabs__header {
    position: static !important;
}

.hidden-Btn {
    /deep/ .el-upload {
        display: none;
    }
}

.font {
    color: windowtext;
    font-size: 15px;
    font-family: "SimSun";
}

.tableStyle {
    text-align: center;
    border: 1px solid #000000;
    border-collapse: collapse;
    table-layout: fixed;
}
</style>



// WEBPACK FOOTER //
// recordTable.vue?49f02d69